export default {"src":"/_next/static/media/icon-best-value.20ef77d7.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};